import {parsePhoneNumberFromString} from 'libphonenumber-js';

export type PhoneState = 'empty' | 'invalid' | 'valid';

export function phoneState(value: string): PhoneState {
  if (!value) {
    return 'empty';
  }
  let parsed;
  try {
    parsed = parsePhoneNumberFromString(value);
  } catch {
    return 'invalid';
  }
  if (!parsed?.nationalNumber) {
    return 'empty';
  }
  return parsed.isValid() ? 'valid' : 'invalid';
}
